module.exports = __webpack_public_path__ + "static/fx_15.cff32dc0.jpg";